import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const NetworkListView = loadable(() => import('../components/NetworkSystem/NetworkListView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('NetworkList own props', ownProps);
    return {
        isAuthenticated: state.AccessReducer.isAuthenticated,
        cognitoUser: state.AccessReducer.cognitoUser,
        userGroupRoles: state.AppReducer.userGroupRoles,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        user: state.AppReducer?.user,
        contextCustomer: state.AppReducer.contextCustomer,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('NetworkList Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(NetworkListView);
